import React from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export function inStockOnly(colors) {
    return colors.filter(color => color.in_stock);
}

export function colorDropDown(color) {
    const {in_stock, id, color_name} = color;
    return [
        in_stock
            ? null
            : <span className="product-description__color-cross-icon" key={`icon_${id}`}>
                <SpriteIcon name="#svg-close" size={{height: 15, width: 15}}/>
            </span>, <span className="product-description__colors-item-details" key={`details_${id}`}>
            <p className="product-description__color-text">{color_name}</p>
            <p className="product-description__color-availability">{I18n.t(`shop.${in_stock ? 'in_stock' : 'out_of_stock'}_text`)}</p>
        </span>
    ];
}

export const imageLoader = (imageUrl, onLoadCallback) => {
    const image = new Image();
    image.onload = onLoadCallback;
    image.src = imageUrl;
};
